<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">{{ page.title }}</h1>
            </div>
        </div>
        <div class="container mb-6">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: 'Contact Us', href: null},
            ]" class="my-6"/>

            <h3 class="font-semibold">Email</h3>
            <p class="mt-1">
                Please email us using this form or send a message to <a href="mailto:archie.leitch@eacts.co.uk">archie.leitch@eacts.co.uk</a>.
            </p>

            <div class="row mt-4">
                <div class="coll-full lg:col-2/3">
                    <form v-if="!form.successful" class="space-y-6" @submit.prevent="onSubmit">

                        <InputBasic
                            label="Name"
                            name="name"
                            placeholder="Enter your name..."
                            required/>

                        <InputBasic
                            label="Email"
                            name="email"
                            placeholder="Enter your name..."
                            required
                            type="email"/>

                        <InputBasic
                            label="Body"
                            name="body"
                            placeholder="Add your message here..."
                            required
                            type="textarea"/>

                        <SubmitButton
                            :disabled="form.errors.any()"
                            :submitting="form.processing"
                            class="py-1 px-3 font-medium border border-grey uppercase hover:grey-light">
                            Send
                        </SubmitButton>

                    </form>
                    <div v-else class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3"
                         role="alert">
                        <p class="text-sm">
                            <strong>Success!</strong> Your message has been sent.
                        </p>
                    </div>
                </div>
                <div class="coll-full mt-6 lg:col-1/3 lg:mt-0">
                    <address class="prose leading-normal not-italic" v-html="page.body"/>
                </div>
            </div>

            <div class="relative aspect-ratio-16/9 mt-6">
                <iframe
                    allowfullscreen
                    class="absolute inset-0 w-full h-full"
                    frameborder="0"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.75700144946!2d-0.6097044337397959!3d51.480974529630835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48767afb5f6c1331%3A0x8e60b186ef0379b1!2sWindsor+SL4+1EU!5e0!3m2!1sen!2suk!4v1474371591456"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import Form from "form-backend-validation";
import SubmitButton from "@app/Shared/Components/SubmitButton";
import InputBasic from "@app/Shared/Components/InputBasic";

export default {

    mixins: [HasMetaData],

    props: {
        page: Object,
    },

    data() {
        return {
            form: new Form({
                name: '',
                email: '',
                body: ''
            })
        };
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        InputBasic,
        SubmitButton
    },

    methods: {
        onSubmit() {
            if (this.form.processing) {
                return;
            }

            this.form.post('/contact');
        }
    }
};

</script>
